export default __webpack_public_path__ + "static/media/dianoiva_4.27af121a.jpg";